import { EAdFoxBannerOnErrorType } from '../types';
export function ensureAdfoxApiAvailable(onError) {
  if (!window.yaContextCb) {
    window.yaContextCb = [];
    var script = window.document.createElement('script');
    script.src = 'https://yandex.ru/ads/system/context.js';
    script.async = true;
    window.document.body.appendChild(script);

    if (onError) {
      script.onerror = function () {
        var error = {
          type: EAdFoxBannerOnErrorType.LoadScriptError,
          message: "Ошибка при загрузке скрипта 'context.js', возможно включен adBlock"
        };
        onError(error);
      };
    }
  }
}